import { useEffect } from "react";
import getWindow from "../utils/window";

function useTouchEventListener(eventName, handler, target) {
  useEffect(() => {
    if (!target || !handler) {
      return;
    }
    target.addEventListener(eventName, handler);

    return () => {
      target.removeEventListener(eventName, handler);
    };
  }, [eventName, handler, target]);
}

export default function useTouchControl({
  startHandler,
  endHandler,
  moveHandler,
  cancelHandler,
  elementRef,
}) {
  const target = elementRef ? elementRef.current : getWindow();

  useTouchEventListener("touchstart", startHandler, target);
  useTouchEventListener("touchend", endHandler, target);
  useTouchEventListener("touchmove", moveHandler, target);
  useTouchEventListener("touchcancel", cancelHandler, target);
}
